export default __webpack_public_path__ + "static/media/Arrow.0e41a9fb.svg";